import instance from "api";
import {IDynamicTableParams} from "components/DynamicTable";
import {IDefectActReasonItem} from "pages/PageDefectActReasons/interfaces";
import {IDictionaryItem} from "components/SimpleDictionary/interfaces";

export const getDefectReasons = (data: IDynamicTableParams) => {
    return instance().post<IDefectActReasonItem[]>("/dictionary/defectActReason/list", data).then(response => response.data);
}

export const getAvailableColumns = () => {
    return instance().post("/dictionary/defectActReason/availableColumns").then(response => response.data);
}

export const getAvailableGroupColumns = () => {
    return instance().post("/dictionary/defectActReason/availableGroupColumns").then(response => response.data);
}

export const addNewDefectReason = (data: IDictionaryItem) => {
    return instance().post("/dictionary/defectActReason/save",
        {defectReasonName: data.name}).then(response => response.data);
}

export const updateDefectReason = (data: IDictionaryItem) => {
    return instance().post("/dictionary/defectActReason/update",
        {defectReasonId: data.id,
            defectReasonName: data.name }).then(response => response.data);
}

export const deleteDefectReason = (defectReasonId: number) => {
    return instance().post("/dictionary/defectActReason/delete",
        {defectReasonId}).then(response => response.data);
}

export const recoverDefectReason = (defectReasonId: number) => {
    return instance().post("/dictionary/defectActReason/recover",
        {defectReasonId}).then(response => response.data);
}

export const getDefectReason = (defectReasonId: number) => {
    return instance().post("/dictionary/defectActReason/get",
        {defectReasonId})
        .then(response => response.data);
}
